<template>
    <div class="intro-wrapper" v-if="info">
        <video
            playsinline="playsinline"
            controls="controls"
            v-src="video"
        ></video>
        <div class="title-line">
            {{ info.detail.title }}
        </div>
        <div class="desc">{{ info.detail.desc }}</div>
    </div>
</template>
<script>
import { getDataRows, getVideoConfig } from '@custouch/proxy-use'

export default {
    data() {
        return {
            info: null,
            video: ''
        }
    },
    async created() {
        const [info] = (
            await getDataRows({
                dataTemplateId: window.env.CMS.template.intro,
                searchKey: '功能详解',
                customIds: ['name'],
                index: 1,
                size: 1
            })
        ).data
        if (info) {
            this.video = (
                await getVideoConfig(info.detail.video.match(/([^/?]+)$/)[1])
            )?.downloadUrl
            this.info = info
        }
    }
}
</script>
<style lang="less" scoped>
.intro-wrapper {
    padding: 1rem;
    padding-top: 0;
}
video {
    width: 100%;
    margin: 1rem 0;
    border-radius: 0.3rem;
}
.desc {
    white-space: pre-line;
}
.title-line {
    display: flex;
    align-items: center;
    color: #1a478b;
    font-size: 1rem;
    margin-bottom: .5rem;
    &::before {
        content: '';
        margin-right: 0.5rem;
        width: 0.2rem;
        height: 0.9rem;
        border-radius: 0.05rem;
        background: #1a478b;
    }
}
</style>
